import { DropdownInputController } from './dropdown-input.controller'

const component = {
  templateUrl: '/workflow/components/dropdown-input/dropdown-input.html?$$REVISION$$',
  bindings: {
    field: '<',
    readOnly: '<',
    variations: '<', // space-delimited
    onChange: '&'
  },
  controllerAs: '$ctrl',
  controller: DropdownInputController
}

export const dropdownInput = component
